// extracted by mini-css-extract-plugin
module.exports = {"color-salmon":"#F5B9A1","colorSalmon":"#F5B9A1","title":"_1oXt8","anchor":"_1Zk4D _2_9gg _1R_Wx"};